<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="3.011 3 18.99 18">
    <path
      d="M 19 17 L 22 17 L 18 21 L 14 17 L 17 17 L 17 3 L 19 3 M 3.011 5.353 L 5.993 5.353 L 5.993 7.647 L 3.011 7.647 L 3.011 5.353 M 8.974 10.576 L 11.956 10.576 L 11.956 12.87 L 8.974 12.87 L 8.974 10.576 M 8.974 14.955 L 11.956 14.955 L 11.956 17.249 L 8.974 17.249 L 8.974 14.955 M 7.981 12.297 L 4.999 12.297 L 4.999 15.529 L 7.981 15.529 L 7.981 16.675 L 4.999 16.675 L 4.005 16.675 L 4.005 8.794 L 4.999 8.794 L 4.999 11.149 L 7.981 11.149 L 7.981 12.297 Z"
    />
  </svg>
</template>
